// CONSTANTS are all caps.
const NS = 'FeaturePanelWidthHalf';
const CLS = 'featurePanelWidthHalf';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class FeaturePanelWidthHalf {
	constructor($el) {
		// $el is the blk node return by the loadFeaturePanelWidthHalf function
		this.$el = $el;
	}

	init() {
		this.setFeaturePanelWidthHalf();
	}

	setFeaturePanelWidthHalf() {
		// Add Some logic here
		let $featurePanel = $(this.$el);
		setTimeout(() => {
			let $btnlist = $featurePanel.find('.featurePanel-ctaWrap .button-btn');
			if ($btnlist.length > 1) {
				let widthLongest = 0;
				$btnlist.each((index, el) => {
					let width = $(el).innerWidth() + 2;
					if (width > widthLongest) widthLongest = width;
				});
				$btnlist.each((index, el) => {
					$(el).css('width', widthLongest + 'px');
				});
			}
		}, 200);
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/featurePanelWidthHalf/js/featurePanelWidthHalf.js